export default {
  required: function required(_ref) {
    var message = _ref.message;
    return function (value) {
      var defaultMessage = 'This field is required';
      return value || message || defaultMessage;
    };
  },
  minValue: function minValue(_ref2) {
    var min = _ref2.min,
        message = _ref2.message;
    return function (value) {
      var parsedValue = parseInt(value.replace(/,/g, ''), 10);
      var defaultMessage = "Please enter a value above ".concat(min - 1);
      return parsedValue >= min || message || defaultMessage;
    };
  },
  maxValue: function maxValue(_ref3) {
    var max = _ref3.max,
        message = _ref3.message;
    return function (value) {
      var parsedValue = parseInt(value.replace(/,/g, ''), 10);
      var defaultMessage = "Please enter a value below ".concat(max + 1);
      return parsedValue <= max || message || defaultMessage;
    };
  },
  minLength: function minLength(_ref4) {
    var min = _ref4.min,
        message = _ref4.message;
    return function (value) {
      var defaultMessage = "Please enter a value longer than ".concat(min - 1, " characters");
      return value && "".concat(value).length >= min || message || defaultMessage;
    };
  },
  maxLength: function maxLength(_ref5) {
    var max = _ref5.max,
        message = _ref5.message;
    return function (value) {
      var defaultMessage = "Please enter a value shorter than ".concat(max + 1, " characters");
      return value && "".concat(value).length <= max || message || defaultMessage;
    };
  },
  valueBetween: function valueBetween(_ref6) {
    var min = _ref6.min,
        max = _ref6.max,
        message = _ref6.message;
    return function (value) {
      var parsedValue = parseInt(value.replace(/,/g, ''), 10);
      var defaultMessage = "Please enter a value between ".concat(min, " and ").concat(max, " (inclusive)");
      return parsedValue <= max && parsedValue >= min || message || defaultMessage;
    };
  },
  deposit: function deposit(_ref7) {
    var message = _ref7.message,
        getValues = _ref7.getValues;
    return function (value) {
      var propertyValue = getValues('propertyValue');
      var parsedValue = parseInt(propertyValue.replace(/,/g, ''), 10);
      var depositValue = parseInt(value.replace(/,/g, ''), 10);

      if (!isNaN(parsedValue) && !isNaN(depositValue)) {
        if (depositValue > parsedValue) {
          return message;
        }
      }
    };
  },
  addressLookup: function addressLookup(_ref8) {
    var message = _ref8.message;
    return function (value) {
      var defaultMessage = 'This field is required';
      var addresses = JSON.parse(value);
      var enoughHistory = addresses.reduce(function (previousValue, currentValue) {
        return previousValue + parseInt(currentValue.yearsAtAddress, 10);
      }, 0);
      var errors = addresses.map(function (address) {
        return address.premise === '' && address.number === '' || address.posttown === '' || address.postcode === '';
      }).filter(function (address) {
        return address;
      });
      return enoughHistory >= 3 && errors.length === 0 || message || defaultMessage;
    };
  },
  addressInput: function addressInput(_ref9) {
    var message = _ref9.message;
    return function (value) {
      var defaultMessage = 'This field is required';
      var address = JSON.parse(value);
      var error = address.premise === '' && address.number === '' || address.posttown === '' || address.postcode === '';
      return !error || message || defaultMessage;
    };
  }
};
//# sourceMappingURL=form-validation-functions.js.map